export const titleCodes = {
    
    synergyTitle: {
        code: "${merchantId}_tmpl_title_1",
        title: "Myanmar Synergy Garment"
    },

    locationTitle: {
        code: "${merchantId}_tmpl_title_6",
        title: "Location"
    },

    phoneTitle: {
        code: "${merchantId}_tmpl_title_13",
        title: "Phone"
    },

    emailTitle: {
        code: "${merchantId}_tmpl_title_14",
        title: "Email"
    },
}


export const textCodes = {
    
    location: {
        code: "${merchantId}_tmpl_text_8",
        text: "No.18/19, Depeyin Wun Htauk U Myae Street, Hlaing Thar Yar Industrial Zone (2), Yangon, Myanmar"
    },

    phone: {
        code: "${merchantId}_tmpl_text_10",
        text: "01-684704"
    },

    email: {
        code: "${merchantId}_tmpl_text_11",
        text: "myanmarsynergygarment@gmail.com"
    },
}


export const imageCodes = {
      
    locationIcon: {
        code: "${merchantId}_tmpl_img_21",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FGroup%2063%20(2).png?alt=media&token=cc407cd6-d28a-431d-aeab-b56906ad9e4b"
    },

    phoneIcon: {
        code: "${merchantId}_tmpl_img_22",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fsample%203.png?alt=media&token=2b210a32-8aab-498e-a562-101f83e85fcf"
    },

    emailIcon: {
        code: "${merchantId}_tmpl_img_23",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fsample%202.png?alt=media&token=ac443372-d1b5-4856-ba14-87dc4b5dbae2"
    },
}
